import { render, staticRenderFns } from "./InformationObligationView.vue?vue&type=template&id=c27961d0&"
import script from "./InformationObligationView.vue?vue&type=script&lang=js&"
export * from "./InformationObligationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports